import { render, staticRenderFns } from "./JacRegionPreview.vue?vue&type=template&id=67c5dfe4&scoped=true"
import script from "./JacRegionPreview.vue?vue&type=script&lang=js"
export * from "./JacRegionPreview.vue?vue&type=script&lang=js"
import style0 from "./JacRegionPreview.vue?vue&type=style&index=0&id=67c5dfe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c5dfe4",
  null
  
)

export default component.exports